// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__XK00-","disabled":"TextArea_disabled__lfLdL"};